<div *appLet="{
  searchCriteria: searchCriteria$ | async,
  stations: stations$ | async,
  appCms: appCms$ | async,
  contentVariant: gbs.growthBook.getFeatureValue(gbf.FEAT_US735_INTERSTITIAL_LOADING_SCREEN,'')
} as $comp"
class="loader">
  @if ($comp.appCms?.loader) {
    <img class="flights-loader" [src]="$comp.appCms!.loader.planeLoader.url">
    <div class="flights-loader__card">
      <div class="flights-loader__card-inner-wrapper" *appLet="getCityName($comp.searchCriteria?.[0]?.destination, $comp.stations) as cityName">
        @switch ($comp.contentVariant) {
          @case ('b') {
            <div class="card-text card-text--primary" [innerHTML]="pasteCityName(cityName, $comp.appCms!.loader!.loadingHeaderHTML)"></div>
            <img [src]="$comp.appCms!.loader!.skytraxAward.url">
            <div class="card-text card-text--secondary" [innerHTML]="$comp.appCms!.loader!.loadingMessageAHTML"></div>
          }
          @case ('c') {
            <div class="card-text card-text--primary" [innerHTML]="pasteCityName(cityName, $comp.appCms!.loader!.loadingHeaderHTML)"></div>
            <img [src]="$comp.appCms!.loader!.norsePlane.url">
            <div class="card-text card-text--secondary" [innerHTML]="$comp.appCms!.loader!.loadingMessageBHTML"></div>
          }
          @case ('d') {
            <div class="card-text card-text--primary" [innerHTML]="pasteCityName(cityName, $comp.appCms!.loader!.loadingHeaderHTML)"></div>
            <img [src]="$comp.appCms!.loader!.tickets.url">
            <div class="card-text card-text--secondary" [innerHTML]="$comp.appCms!.loader!.loadingMessageCHTML"></div>
          }
          @case ('e') {
            <div class="card-text card-text--primary" [innerHTML]="pasteCityName(cityName, $comp.appCms!.loader!.loadingHeaderHTML)"></div>
            <img [src]="$comp.appCms!.loader!.checkOk.url">
            <div class="card-text card-text--secondary" [innerHTML]="$comp.appCms!.loader!.loadingMessageDHTML"></div>
          }
        }
      </div>
    </div>
  }
</div>
